export const LIST_STATUS_MEMBER = [
  { value: 0, label: 'Chưa kích hoạt', color: '#FF9500' },
  { value: 1, label: 'Đã kích hoạt', color: '#5CB85C' },
  { value: 2, label: 'Đã xóa', color: '#EB3D4D' },
  { value: 3, label: 'Đã khóa', color: '#EB3D4D' },
];

export const LIST_STATUS_ROLE = [
  { value: 0, label: 'Chưa duyệt', color: '#FF9500' },
  { value: 1, label: 'Đã duyệt', color: '#5CB85C' },
];

export const LIST_STATUS_PARTNER = [
  { value: 0, label: 'Chờ duyệt', color: '#FF9500' },
  { value: 1, label: 'Đã duyệt', color: '#5CB85C' },
  { value: 2, label: 'Đã xóa', color: '#EB3D4D' },
  { value: 3, label: 'Ngừng hợp tác', color: '#EB3D4D' },
];

export const LIST_STATUS_CAMPAIGN = [
  { value: 0, label: 'Chờ duyệt', color: '#FF9500' },
  { value: 1, label: 'Đã duyệt', color: '#5CB85C' },
  { value: 2, label: 'Đã xóa', color: '#EB3D4D' },
  { value: 3, label: 'Tạm dừng', color: '#EB3D4D' },
  { value: 4, label: 'Kết thúc', color: '#EB3D4D' },
  { value: 5, label: 'Từ chối', color: '#EB3D4D' },
];

export const LIST_STATUS_POPUP = [
  { value: 0, label: 'Chờ duyệt', color: '#FF9500' },
  { value: 1, label: 'Đã duyệt', color: '#5CB85C' },
  { value: 2, label: 'Đã xóa', color: '#EB3D4D' },
  { value: 3, label: 'Tạm dừng', color: '#EB3D4D' },
  { value: 4, label: 'Kết thúc', color: '#007BFF' },
];

//hiện thị ẩn hiện 0-1
export const LIST_APPEARANCE = [
  { value: 0, label: 'Ẩn', color: '#EB3D4D' },
  { value: 1, label: 'Hiện', color: '#5CB85C' },
];

export const LIST_STATUS_NOTIFICATION = [
  { value: 0, label: 'Chờ duyệt', color: '#FF9500' },
  { value: 1, label: 'Đã duyệt', color: '#5CB85C' },
  { value: 2, label: 'Đã xóa', color: '#EB3D4D' },
  { value: 3, label: 'Đang push', color: '#FF9500' },
  { value: 4, label: 'Đã push', color: '#5CB85C' },
  { value: 5, label: 'Đã duyệt (của hệ thống)', color: '#5CB85C' },
  { value: 6, label: 'Push lỗi', color: '#EB3D4D' },
  { value: 7, label: 'Quá thời hạn push nhưng chưa push thành công', color: '#EB3D4D' },
];

export const LIST_BANNER_PAGE = [
  { value: '1', label: 'App Trang chủ' },
  { value: '2', label: 'App Tử vi - Phong thủy' },
  { value: '3', label: 'App Khám phá' },
  { value: '4', label: 'App_Trangchu_feature' },
  { value: '5', label: 'App Tử vi - Phong thủy - Tính năng' },
  { value: '6', label: 'App Tâm An' },
  { value: '7', label: 'App Cộng đồng' },
  { value: '8', label: 'App Chi tiết ngày' },
  { value: '9', label: 'App Lịch Tháng' },
  { value: '10', label: 'App Xem Ngày Tốt' },
  { value: '11', label: 'App Lục hào' },
  { value: '12', label: 'App_ListSuKien_mrec' },
  { value: '13', label: 'App_ChitietSukien_mrec' },
  { value: '14', label: 'App_TaoSukien_mrec' },
  { value: '15', label: 'App_ThanhvienGiadinh_mrec' },
  { value: '16', label: 'App_Default_Mrec' },
  { value: '17', label: 'App_MucdoHopnhau_mrec' },
  { value: '18', label: 'App_LichThang_mrec' },
  { value: '19', label: 'App_MaGiamGia' },
  { value: '20', label: 'App_ChiTietNgay_mrec' },
  { value: '21', label: 'App_Popupmrec' },
  { value: '22', label: 'App_ThanSoHoc_mrec' },
  { value: '23', label: 'App_LichTuVan' },
  { value: '24', label: 'App_Onlinestore_medium' },
  { value: '25', label: 'App_Chaoxuan' },
  { value: '26', label: 'App_CapnhatThongtin' },
  { value: '27', label: 'App_DatTenCon' },
  { value: '28', label: 'App_HomeFloatBtn' },
];

export const LIST_PLATFORM = [
  { value: null, label: 'Tất cả' },
  { value: 'iOS', label: 'iOS' },
  { value: 'Android', label: 'Android' },
];

export const LIST_BANNER_TYPE = [
  { value: 3, label: 'Inline trang kích thước lớn (660x430)' },
  { value: 4, label: 'Inline trang kích thước nhỏ (660x310)' },
];

export const LIST_POPUP_TYPE = [
  { value: 'popup', label: 'Mở popup' },
  { value: 'scroll_down', label: 'Cuộn xuống' },
  { value: 'full_screen', label: 'Full màn hình' },
  { value: 'deeplink', label: 'Open app Deeplink' },
  { value: 'popup_mrec', label: 'Quảng cáo inline dạng popup' },
];

export const LIST_POPUP_CONTENT_TYPE = [
  { value: 'LDP', label: 'LDP' },
  { value: 'Image', label: 'Image' },
  { value: 'Mrec', label: 'Mrec' },
  { value: 'Video', label: 'Video' },
  { value: 'LDPNavigation', label: 'LDP dạng navigation' },
  { value: 'DangkyDichvu', label: 'DangkyDichvu' },
  { value: 'Deeplink', label: 'Deeplink' },
  { value: 'Webview', label: 'Webview' },
  { value: 'KHNLCN', label: 'KHNLCN' },
];

export const LIST_CATEGORY_NOTIFICATION = [
  { value: 1, label: 'Thông báo' },
  { value: 2, label: 'Ưu đãi' },
];

export const LIST_ACTIONS = [
  { value: 1, label: 'Xem danh sách' },
  { value: 2, label: 'Xem chi tiết' },
  { value: 3, label: 'Tạo mới' },
  { value: 4, label: 'Chỉnh sửa' },
  { value: 5, label: 'Xóa' },
  { value: 6, label: 'Duyệt' },
  { value: 7, label: 'Tạm dừng' },
  { value: 8, label: 'Tiếp tục' },
  { value: 9, label: 'Xuất báo cáo' },
  { value: 10, label: 'Xem biểu đồ thống kê' },
  { value: 11, label: 'Xem dữ liệu thống kê' },
  { value: 12, label: 'Sao chép' },
];
